import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import BottomTab from '../components/BottomTab';
import { FiSearch, FiImage, FiCalendar } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
import SimpleCalendar from '../components/SimpleCalendar';
import { FaChevronRight, FaCheck, FaTimes } from 'react-icons/fa';
import { BookRegType, BookEventType, AcceptMethod, acceptMethod2text, bookEventType2text } from '../common/enums';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { getBookByBookId, getBookByIsbn } from '../api/BookApi';
import { getMissiondoneTypes, getBookevent, uploadBookEventImageToTmpFile, modifyBookevent, createBookevent } from '../api/BookeventApi';
import { set } from 'lodash';
import MessageModal from '../components/MessageModal';
import LoadingOverlay from '../components/LoadingOverlay';
import BookSearchPage from './BookSearchPage';

const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
`;
const TabRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1.5px solid #e0e0e0;
  background: #eae8e9;
`;
const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.active ? '#222' : '#bdbdbd'};
  border-bottom: ${props => props.active ? '3px solid #222' : 'none'};
  padding: 14px 0 10px 0;
  cursor: pointer;
`;
const ContentSection = styled.div`
  background: #fff;
  padding: 32px 20px 120px 20px; // 하단 패딩을 120px로 늘림
`;
const ContentTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #404040;
  margin-bottom: 24px;
`;
const FormRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 0;
  gap: 0;
`;
const FormLabel = styled.div`
  flex: 0 0 110px;
  font-size: 15px;
  color: #444;
  font-weight: 400;
  text-align: left;
  display: flex;
  align-items: center;
`;
const FormInput = styled.input`
  flex: 1;
  height: 36px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 16px;
  padding: 0 10px;
  box-sizing: border-box;
`;
const FormTextArea = styled.textarea`
  flex: 1;
  min-height: 80px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 16px;
  padding: 8px 10px;
  resize: none;
  box-sizing: border-box;
`;
const FormValue = styled.div`
  flex: 1;
  font-size: 16px;
  color: #444;
  text-align: left;
`;
const FormArrow = styled.span`
  margin: 0 8px;
  color: #bbb;
`;
const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
`;
const SearchIcon = styled(FiSearch)`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #bbb;
  cursor: pointer;
`;
const SearchInput = styled(FormInput)`
  padding-left: 32px;
  width: 100%;
  box-sizing: border-box;
`;
const ImageUploadBox = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  color: #888;
  font-size: 14px;
  cursor: pointer;
  height: 36px;
  padding-left: 12px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin: 40px 0 0 0;
  justify-content: center;
`;

const RegisterButton = styled.button`
  flex: 1;
  max-width: 200px;
  background: #244AC2;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(36,74,194,0.08);
  transition: background 0.15s;
  font-weight: 500;
  &:active {
    background: #193a99;
  }
`;

const CancelButton = styled.button`
  flex: 1;
  max-width: 200px;
  background: #9e9e9e;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(158,158,158,0.08);
  transition: background 0.15s;
  font-weight: 500;
  &:active {
    background: #757575;
  }
`;

const HashTagInput = styled.input`
  flex: 1;
  height: 36px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 16px;
  padding: 0 10px;
  box-sizing: border-box;
`;

const HashTagTable = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

const HashTagItem = styled.div`
  background: #eae8e9;
  color: #244ac2;
  border-radius: 16px;
  padding: 6px 14px 6px 12px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RemoveTagBtn = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 16px;
  cursor: pointer;
  margin-left: 2px;
`;

const Selector = styled.div`
  flex: 1;
  height: 36px;
  border: 1px solid #e1e1e1;
  background: #f7f7f7;
  border-radius: 0;
  font-size: 14px;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: #444;
`;

const ArrowIcon = styled(FaChevronRight)`
  font-size: 13px;
  color: #bbb;
`;

const Dropdown = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #555;
  font-weight: 500;
  cursor: pointer;
  min-width: 80px;
  font-size: 14px;
`;

const DropdownList = styled.div`
  position: absolute;
  left: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  z-index: 10;
  min-width: 180px;
  ${({ position }) => position === 'top' && 'bottom: 110%; top: auto;'}
  ${({ position }) => position === 'bottom' && 'top: 110%;'}
`;

const DropdownItem = styled.div`
  padding: 10px 18px;
  color: #555;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background: #f5f5f7;
  }
  &.selected {
    color: #1976d2;
    font-weight: 700;
  }
`;

const CheckIcon = styled(FaCheck)`
  font-size: 12px;
  color: #1976d2;
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
`;



const SmallCloseButton = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  background: #f5f5f7;
  border: 1px solid #eee;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
  font-size: 10px;
  transition: background-color 0.2s;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 11;
  
  &:hover {
    background: #e0e0e0;
  }
`;


const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;


const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;



const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;


const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 20px 20px 20px;
`;

export default function MoimRecruitPage({ editBookEventId, onClose }) {
  const [tab, setTab] = useState('review');
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [isbn, setIsbn] = useState(params.get('isbn'));
  const [bookId, setBookId] = useState(params.get('bookId'));
  if(!editBookEventId) {
    editBookEventId = params.get('bookEventId');
  }
  const [bookEventId, setBookEventId] = useState(editBookEventId);
  const [eventTitle, setEventTitle] = useState('');
  const [eventImageFile, setEventImageFile] = useState(null);
  const [eventType, setEventType] = useState(BookEventType.RECRUIT_REVIEWER);
  const [bookTitle, setBookTitle] = useState('');
  const [bookAuthor, setBookAuthor] = useState('');
  const [briefIntroduction, setBriefIntroduction] = useState('');
  const [detailsLinkUrl, setDetailsLinkUrl] = useState('');
  const [mission, setMission] = useState('');
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [tmpImageId, setTmpImageId] = useState(null);
  const [hashTag, setHashTag] = useState('');
  const [hashTags, setHashTags] = useState([]);
  const [deadlineDate, setDeadlineDate] = useState('');
  const [showDeadlineCal, setShowDeadlineCal] = useState(false);
  const [recruitNum, setRecruitNum] = useState(0);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const deadlineCalRef = useRef(null);
  const [acceptMethod, setAcceptMethod] = useState(AcceptMethod.ADMIN_APPROVAL);
  const [showParticipationDropdown, setShowParticipationDropdown] = useState(false);
  const participationDropdownRef = useRef(null);
  const [participationDropdownPosition, setParticipationDropdownPosition] = useState('bottom');
  
  // 링크제출 방법 관련 상태 추가
  const [missionTypes, setMissionTypes] = useState([]);
  const [selectedMissionTypes, setSelectedMissionTypes] = useState([]);
  const [showMissionTypeDropdown, setShowMissionTypeDropdown] = useState(false);
  const missionTypeDropdownRef = useRef(null);
  
  // 모집시작일 관련 상태 추가
  const [startDate, setStartDate] = useState('');
  const [showStartCal, setShowStartCal] = useState(false);
  const startCalRef = useRef(null);

  // 모집유형 드롭다운 관련 상태 추가
  const [showEventTypeDropdown, setShowEventTypeDropdown] = useState(false);
  const eventTypeDropdownRef = useRef(null);

  // 활동마감일 관련 상태 추가
  const [missionCompletedAt, setMissionCompletedAt] = useState('');
  const [showMissionCompletedCal, setShowMissionCompletedCal] = useState(false);
  const missionCompletedCalRef = useRef(null);

  const { showBack, setShowBack, bookEventInput, setBookEventInput, bookEventFile, setBookEventFile } = useNoobookContext();
  
  const [showBookSearchModal, setShowBookSearchModal] = useState(false);

  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(!onClose);
    if(editBookEventId) {
      console.log('editBookEventId', editBookEventId);
      setBookEventInput(null);
      setBookEventFile(null);
    }
    loadData();
    return () => setShowBack(prevShowBack);
  }, []);

  // 참여 방법 드롭다운 외부 클릭 시 닫기
  useEffect(() => {
    function handleClick(e) {
      if (participationDropdownRef.current && !participationDropdownRef.current.contains(e.target)) {
        setShowParticipationDropdown(false);
      }
      if (missionTypeDropdownRef.current && !missionTypeDropdownRef.current.contains(e.target)) {
        setShowMissionTypeDropdown(false);
      }
      if (eventTypeDropdownRef.current && !eventTypeDropdownRef.current.contains(e.target)) {
        setShowEventTypeDropdown(false);
      }
      if (startCalRef.current && !startCalRef.current.contains(e.target)) {
        setShowStartCal(false);
      }
      if (deadlineCalRef.current && !deadlineCalRef.current.contains(e.target)) {
        setShowDeadlineCal(false);
      }
      if (missionCompletedCalRef.current && !missionCompletedCalRef.current.contains(e.target)) {
        setShowMissionCompletedCal(false);
      }
    }
    if (showParticipationDropdown || showMissionTypeDropdown || showEventTypeDropdown || showStartCal || showDeadlineCal || showMissionCompletedCal) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showParticipationDropdown, showMissionTypeDropdown, showEventTypeDropdown, showStartCal, showDeadlineCal, showMissionCompletedCal]);


  const loadData = async () => {
    if(loading) {
      return;
    }
    setLoading(true);
    try {
      await loadBookEventInput();
      await loadBookInfo(null, null);
      await loadMissionTypes();
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };


  // 링크제출 방법 데이터 로드
  const loadMissionTypes = async () => {
    try {
      const { accessToken } = await getAccessToken();
      const response = await getMissiondoneTypes(accessToken || '');
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setMissionTypes(processedResponse.data || []);
      } else {
        console.error('미션 타입 로드 실패:', processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('미션 타입 로드 중 오류:', error);
    }
  };

  // 링크제출 방법 선택/해제 처리
  const handleMissionTypeToggle = (missionTypeId) => {
    setSelectedMissionTypes(prev => {
      if (prev.includes(missionTypeId)) {
        return prev.filter(id => id !== missionTypeId);
      } else {
        return [...prev, missionTypeId];
      }
    });
  };

  // 링크제출 방법 드롭다운 위치 계산
  const handleMissionTypeDropdown = () => {
    if (!missionTypeDropdownRef.current) return setShowMissionTypeDropdown(v => !v);
    const rect = missionTypeDropdownRef.current.getBoundingClientRect();
    const popupHeight = 200; // 드롭다운 예상 높이
    const bottomTabHeight = 64; // BottomTab 높이
    const availableBottomSpace = window.innerHeight - rect.bottom - bottomTabHeight;
    
    if (availableBottomSpace < popupHeight) {
      // 아래쪽 공간이 부족하면 위쪽에 표시
      setShowMissionTypeDropdown(v => !v);
    } else {
      setShowMissionTypeDropdown(v => !v);
    }
  };

  const loadBookEventInput = async () => {
    if(!editBookEventId) {
      if(bookEventFile) {
        setEventImageFile(bookEventFile);
      }
      if(bookEventInput) {
        console.log('bookEventInput', bookEventInput);
        setBookEventId(bookEventInput.id);
        setEventTitle(bookEventInput.title);
        setEventType(bookEventInput.eventType);
        setStartDate(bookEventInput.recruitFr);
        setDeadlineDate(bookEventInput.recruitTo);
        //setDeadlineDate(bookEventInput.announceAt);
        setMissionCompletedAt(bookEventInput.missionCompletedAt);
        setTmpImageId(bookEventInput.tmpImageId);
        setPreviewUrl(bookEventInput.imageId);
        //setImageId(bookEventInput.imageId);
        setBriefIntroduction(bookEventInput.briefIntroduction);
        setDetailsLinkUrl(bookEventInput.detailsLinkUrl || '');
        setMission(bookEventInput.mission);
        setRecruitNum(bookEventInput.recruitNum);
        setAcceptMethod(bookEventInput.acceptMethod);
        setHashTags(bookEventInput.hashtags);
        setSelectedMissionTypes(bookEventInput.missionTypes);
        if(!bookId) {
          const cbookId = bookEventInput.books?.[0]?.bookId;
          setBookId(cbookId);
          loadBookInfo(cbookId, null);
        }
        return;
      }
    }
    if(bookEventId) {
      const {accessToken} = await getAccessToken();
      const resp = await getBookevent(accessToken, bookEventId);
      const processedResp = processApiResponse(resp);
      if(processedResp.success) {
        console.log('processedResp.data', processedResp.data);

        setEventTitle(processedResp.data?.title);
        setEventType(processedResp.data?.eventType);
        setStartDate(processedResp.data?.recruitFr);
        setDeadlineDate(processedResp.data?.recruitTo);
        //setDeadlineDate(bookEventInput.announceAt);
        setMissionCompletedAt(processedResp.data?.missionCompletedAt);
        //setTmpImageId(bookEventInput.tmpImageId);
        setPreviewUrl(processedResp.data?.imgUrl);
        setEventImageFile(null);
        //setImageId(bookEventInput.imageId);
        setBriefIntroduction(processedResp.data?.briefIntroduction);
        setDetailsLinkUrl(processedResp.data?.detailsLinkUrl || '');
        setMission(processedResp.data?.mission);
        setRecruitNum(processedResp.data?.recruitNum);
        setAcceptMethod(processedResp.data?.acceptMethod);
        setHashTags(processedResp.data?.hashtags);
        setSelectedMissionTypes(processedResp.data?.missiondoneTypes?.map(missionType => missionType.id));
        const cbookId = processedResp.data.books?.[0]?.id;
        setBookId(cbookId);
        loadBookInfo(cbookId, null);
      }
    } 
  };

  

  useEffect(() => {
    if(eventImageFile) {
        const url = URL.createObjectURL(eventImageFile);
        setPreviewUrl(url);    
    }
    setBookEventFile(eventImageFile);
    setBookEventInput({
      id: bookEventId,
      title: eventTitle,
      eventType: eventType,
      recruitFr: startDate,
      recruitTo: deadlineDate,
      announceAt: new Date(),
      missionCompletedAt: missionCompletedAt,
      tmpImageId: tmpImageId,
      //imageId: previewUrl,
      briefIntroduction: briefIntroduction,
      detailsLinkUrl: detailsLinkUrl || null,
      mission: mission,
      recruitNum: recruitNum,
      acceptMethod: acceptMethod,
      books: [
        {
          id: bookId,
          isbn: isbn?.length < 13 ? isbn : null,
          isbn13: isbn?.length >= 13 ? isbn : null,
        }
      ],
      tmpImageId: tmpImageId,
      hashtags: hashTags,
      missionTypes: selectedMissionTypes
    });
  }, [eventImageFile, bookEventId, eventTitle, eventType, startDate, deadlineDate, missionCompletedAt, tmpImageId, briefIntroduction, detailsLinkUrl, mission, recruitNum, acceptMethod, bookId, hashTags, selectedMissionTypes]);


  

  const loadBookInfo = async (argBookId, argIsbn, forceArg = false) => {
      const cbookId = argBookId || forceArg ? argBookId : bookId;
      const cisbn = argIsbn || forceArg ? argIsbn : isbn;
      setErrorMessage('');
      if (cbookId) {
        const {accessToken} = await getAccessToken();
        const resp = await getBookByBookId(accessToken, cbookId);
        const processedResp = processApiResponse(resp);
        if(processedResp.success) {
          if(processedResp.data) {
            setBookTitle(processedResp.data.title);
            setBookAuthor(processedResp.data.author);
          }
        } else {
          setErrorMessage(processedResp.errorMessage);
        }
      } else if (cisbn) {
        const {accessToken} = await getAccessToken();
        const resp = await getBookByIsbn(accessToken, cisbn);
        const processedResp = processApiResponse(resp);
        if(processedResp.success) {
          if (processedResp.data) {    
            console.log('processedResp.data', processedResp.data);
            setBookId(processedResp.data.bookId);
            setBookTitle(processedResp.data.title);
            setBookAuthor(processedResp.data.author);
          }
        } else {
          setErrorMessage(processedResp.errorMessage);
        }
      }
  };

  const cancelBookEvent = () => {
    resetData();
    if(onClose) { 
      onClose(false);
    } else {
      navigate(-1);
    }
  };

  const saveBookEvent = async () => {
    if(loading) {
      return;
    }
    setLoading(true);
    try {
    const {accessToken} = await getAccessToken();
    if(eventImageFile) {
      const tmpImgResp = await uploadBookEventImageToTmpFile(accessToken, eventImageFile);
      const processedTmpImgResp = processApiResponse(tmpImgResp);

      if(processedTmpImgResp.success) {
        //console.log('tmpImgResp 1 success', tmpImgResp);
        bookEventInput.tmpImageId = processedTmpImgResp.data?.fileId;
      } else {
       // console.log('tmpImgResp 2 error', tmpImgResp);
        setErrorMessage(processedTmpImgResp?.errorMessage);
        return;
      }
    }
    console.log('bookEventInput', bookEventInput, bookId);
    if(bookEventId) {
        const resp = await modifyBookevent(accessToken, bookEventId, bookEventInput);
        const processedResp = processApiResponse(resp);
        if(processedResp.success) {
          resetData();
          if(onClose) {
            onClose(true);
          } else {
            navigate(-1);
          }
        } else {
          setErrorMessage(processedResp.errorMessage);
          return;
        }
      } else {
        const resp = await createBookevent(accessToken, bookEventInput);
        const processedResp = processApiResponse(resp);
        if(processedResp.success) {
          resetData();
          if(onClose) { 
            onClose(true);
          } else {
            navigate(-1);
          }
        } else {
          setErrorMessage(processedResp.errorMessage);
          return;
        }
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const resetData = () => {
    setBookEventInput(null);
    setBookEventFile(null);
  };


  const handleBookSearchModalClose = (isbn, bookId) => {
    setShowBookSearchModal(false);
    setIsbn(isbn);
    setBookId(bookId);
    loadBookInfo(bookId, isbn, true);
  };

  const handleSearchIconClick = () => {
    setShowBookSearchModal(true);
  };

  // 참여 방법 드롭다운 위치 계산
  const handleParticipationDropdown = () => {
    if (!participationDropdownRef.current) return setShowParticipationDropdown(v => !v);
    const rect = participationDropdownRef.current.getBoundingClientRect();
    const popupHeight = 180;
    if (window.innerHeight - rect.bottom < popupHeight) {
      setParticipationDropdownPosition('top');
    } else {
      setParticipationDropdownPosition('bottom');
    }
    setShowParticipationDropdown(v => !v);
  };

  //const participationMethods = ['관리자 승인 후 참여', '선착순 마감', '신청 후 자동 승인'];
  const acceptMethods = [AcceptMethod.ADMIN_APPROVAL];//, AcceptMethod.FIRST_COME_FIRST_SERVED, AcceptMethod.AUTO_APPROVAL];
  const handleFileInputClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setEventImageFile(file);
  };
  const handleHashTagAdd = (e) => {
    e.preventDefault();
    const tag = hashTag.trim();
    if (tag && !hashTags.includes(tag)) {
      setHashTags([...hashTags, tag]);
      setHashTag('');
    }
  };
  const handleHashTagRemove = (tag) => {
    setHashTags(hashTags.filter(t => t !== tag));
  };

  // 모집유형 선택 핸들러
  const handleEventTypeSelect = (selectedEventType) => {
    setEventType(selectedEventType);
    setShowEventTypeDropdown(false);
  };

  const handleCloseErrorModal = () => {
    setErrorMessage('');
  };

  return (
    <PageWrapper>
      <TabRow>
        <Tab active={tab==='review'} >서평·필사단</Tab>
        <Tab active={tab==='recommend'} >추천모임</Tab>
      </TabRow>
      <ContentSection>
        {!onClose && <ContentTitle>서평·필사단 모집하기</ContentTitle> }
        
        <FormRow>
          <FormLabel>모집유형</FormLabel>
          <div style={{position:'relative'}} ref={eventTypeDropdownRef}>
            <FormValue 
              style={{
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                cursor: 'pointer',
                fontSize: '14px'
              }}
              onClick={() => setShowEventTypeDropdown(v => !v)}
            >
              {eventType ? bookEventType2text(eventType) : '모집유형을 선택해주세요'}
              <FaChevronRight size={12} color="#bbb" />
            </FormValue>
            {showEventTypeDropdown && (
              <DropdownList>
                {Object.values(BookEventType).map((type) => (
                  <DropdownItem 
                    key={type}
                    onClick={() => handleEventTypeSelect(type)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    {bookEventType2text(type)}
                    {eventType === type && <CheckIcon><FaCheck /></CheckIcon>}
                  </DropdownItem>
                ))}
              </DropdownList>
            )}
          </div>
        </FormRow>
        
        <FormRow>
          <FormLabel>모집명</FormLabel>
          <FormInput placeholder="모집명을 입력해주세요" value={eventTitle} onChange={e => setEventTitle(e.target.value)} />
        </FormRow>
        <FormRow>
          <FormLabel>도서명</FormLabel>
          <SearchInputWrapper>
            <SearchIcon size={20} onClick={handleSearchIconClick} />
            <SearchInput placeholder="도서를 선택해주세요" value={bookTitle} readOnly />
          </SearchInputWrapper>
        </FormRow>
        <FormRow>
          <FormLabel>저자명</FormLabel>
          <FormInput placeholder="" value={bookAuthor} readOnly />
        </FormRow>
        <FormRow>
          <FormLabel>도서 사진 업로드</FormLabel>
          <ImageUploadBox onClick={handleFileInputClick}>
            <FiImage size={18} style={{marginRight:4, color:'#1976d2'}} />
            이미지 파일 업로드하기
          </ImageUploadBox>
          <input type="file" ref={fileInputRef} style={{display:'none'}} accept="image/*" onChange={handleFileChange} />
          {previewUrl && (
            <img src={previewUrl} alt="미리보기" style={{marginTop:12, maxWidth:'100%', maxHeight:120, border:'1px solid #eee', borderRadius:8}} />
          )}
        </FormRow>
        <FormRow>
          <FormLabel>간단 책 소개</FormLabel>
          <FormTextArea placeholder="책의 간단한 소개를 입력해주세요." value={briefIntroduction} onChange={e => setBriefIntroduction(e.target.value)} />
        </FormRow>
        <FormRow>
          <FormLabel>자세히보기 링크</FormLabel>
          <FormInput
            placeholder="https://..."
            value={detailsLinkUrl}
            onChange={e => setDetailsLinkUrl(e.target.value)}
          />
        </FormRow>
        {/* 해시태그 입력란 */}
        <FormRow>
          <FormLabel>해시태그</FormLabel>
          <form style={{flex:1, display:'flex'}} onSubmit={handleHashTagAdd}>
            <HashTagInput
              placeholder="태그 입력 후 Enter"
              value={hashTag}
              onChange={e => setHashTag(e.target.value)}
              maxLength={20}
            />
          </form>
        </FormRow>
        {/* 해시태그 테이블 */}
        {hashTags?.length > 0 && (
          <HashTagTable>
            {hashTags?.map(tag => (
              <HashTagItem key={tag}>
                #{tag}
                <RemoveTagBtn type="button" onClick={()=>handleHashTagRemove(tag)}>×</RemoveTagBtn>
              </HashTagItem>
            ))}
          </HashTagTable>
        )}
        <FormRow>
          <FormLabel>모집 시작일</FormLabel>
          <div style={{position:'relative'}} ref={startCalRef}>
            <FormValue 
              style={{
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                cursor: 'pointer',
                fontSize: '14px'
              }}
              onClick={() => setShowStartCal(v => !v)}
            >
              {startDate || '모집 시작일 선택'}
              <FiCalendar size={16} color="#bbb" />
            </FormValue>
            {showStartCal && (
              <SimpleCalendar
                value={startDate}
                onSelect={setStartDate}
                onClose={() => setShowStartCal(false)}
                anchorRef={startCalRef}
              />
            )}
          </div>
        </FormRow>
        <FormRow>
          <FormLabel>모집 마감일</FormLabel>
          <div style={{position:'relative'}} ref={deadlineCalRef}>
            <FormValue 
              style={{
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                cursor: 'pointer',
                fontSize: '14px'
              }}
              onClick={() => setShowDeadlineCal(v => !v)}
            >
              {deadlineDate || '모집 마감일 선택'}
              <FiCalendar size={16} color="#bbb" />
            </FormValue>
            {showDeadlineCal && (
              <SimpleCalendar
                value={deadlineDate}
                onSelect={setDeadlineDate}
                onClose={() => setShowDeadlineCal(false)}
                anchorRef={deadlineCalRef}
              />
            )}
          </div>
        </FormRow>
        <FormRow>
          <FormLabel>모집인원</FormLabel>
          <FormInput 
            type="number" 
            min="1"
            placeholder="모집인원을 입력해주세요" 
            value={recruitNum || ''} 
            onChange={e => {
              const value = parseInt(e.target.value) || 0;
              setRecruitNum(value);
            }}
          />
        </FormRow>
        <FormRow>
          <FormLabel>필수 활동</FormLabel>
          <FormTextArea placeholder="" value={mission} onChange={e => setMission(e.target.value)} />
        </FormRow>
        
        <FormRow>
          <FormLabel>활동마감일</FormLabel>
          <div style={{position:'relative'}} ref={missionCompletedCalRef}>
            <FormValue 
              style={{
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                cursor: 'pointer',
                fontSize: '14px'
              }}
              onClick={() => setShowMissionCompletedCal(v => !v)}
            >
              {missionCompletedAt || '활동마감일 선택'}
              <FiCalendar size={16} color="#bbb" />
            </FormValue>
            {showMissionCompletedCal && (
              <SimpleCalendar
                value={missionCompletedAt}
                onSelect={setMissionCompletedAt}
                onClose={() => setShowMissionCompletedCal(false)}
                anchorRef={missionCompletedCalRef}
              />
            )}
          </div>
        </FormRow>
        
        <FormRow>
          <FormLabel>참여 방법</FormLabel>
          <Dropdown ref={participationDropdownRef}>
            <DropdownButton onClick={handleParticipationDropdown}>
              {acceptMethod2text(acceptMethod) || '참여 방법 선택'}
              <ArrowIcon />
            </DropdownButton>
            {showParticipationDropdown && (
              <DropdownList position={participationDropdownPosition}>
                {acceptMethods.map(method => (
                  <DropdownItem
                    key={method}
                    className={acceptMethod === method ? 'selected' : ''}
                    onClick={() => {
                      setAcceptMethod(method);
                      setShowParticipationDropdown(false);
                    }}
                  >
                    {acceptMethod2text(method)}
                  </DropdownItem>
                ))}
              </DropdownList>
            )}
          </Dropdown>
        </FormRow>

        <FormRow>
          <FormLabel>링크제출 방법</FormLabel>
          <Dropdown ref={missionTypeDropdownRef}>
            <DropdownButton onClick={handleMissionTypeDropdown}>
              {selectedMissionTypes?.length > 0 
                ? `${selectedMissionTypes?.length}개 선택됨`
                : '링크제출 방법 선택'
              }
              <ArrowIcon />
            </DropdownButton>
            {showMissionTypeDropdown && (
              <DropdownList position={(() => {
                if (!missionTypeDropdownRef.current) return 'bottom';
                const rect = missionTypeDropdownRef.current.getBoundingClientRect();
                const popupHeight = 200;
                const bottomTabHeight = 64;
                const availableBottomSpace = window.innerHeight - rect.bottom - bottomTabHeight;
                return availableBottomSpace < popupHeight ? 'top' : 'bottom';
              })()}>
                {missionTypes.map(missionType => (
                  <DropdownItem
                    key={missionType.id}
                    className={selectedMissionTypes.includes(missionType.id) ? 'selected' : ''}
                    onClick={() => {
                      handleMissionTypeToggle(missionType.id);
                      // 클릭 시 닫히지 않도록 함
                    }}
                  >
                    <CheckIcon visible={selectedMissionTypes.includes(missionType.id)} />
                    {missionType.typeName}
                  </DropdownItem>
                ))}
                <SmallCloseButton onClick={() => setShowMissionTypeDropdown(false)}>
                  <FaTimes />
                </SmallCloseButton>
              </DropdownList>
            )}
          </Dropdown>
        </FormRow>

        <ButtonContainer>
        <RegisterButton onClick={saveBookEvent}>{bookEventId ? '수정하기' : '등록하기'}</RegisterButton>
          <CancelButton onClick={cancelBookEvent}>취소</CancelButton>
        </ButtonContainer>
      </ContentSection>
      {/*<BottomTab selected="moim" onTabChange={onTabChange} />*/}
      
      {/* 에러 메시지 모달 */}
      <MessageModal
        isOpen={!!errorMessage}
        message={errorMessage}
        onClose={handleCloseErrorModal}
        title="오류"
      />
      
      {/* 로딩 오버레이 */}
      {loading && <LoadingOverlay />}

      {/* 도서 검색 모달 */}
      {showBookSearchModal && (
        <Modal>
          <ModalHeader>
            <ModalTitle>도서 검색</ModalTitle>
            <CloseButton onClick={()=>handleBookSearchModalClose(null, null)}>
              <FaTimes />
            </CloseButton>
          </ModalHeader>
          <ModalContent>
            <BookSearchPage onClose={handleBookSearchModalClose} />
          </ModalContent>
        </Modal>
      )}
    </PageWrapper>
  );
} 